export default "__VITE_ASSET__07a7e8ac__"